import { memo } from 'react';

import { Tally2Icon } from 'lucide-react';

import { cn } from '@/lib/utils';

interface AssignmentResizeHandlesProps {
  isResizeLeftDisabled: boolean;
  isResizeRightDisabled: boolean;
  isResizing: 'left' | 'right' | false;
  isDragging: boolean;
  textColor: string;
  opacity: number;
  onMouseDownLeft: (e: React.MouseEvent<HTMLDivElement>) => void;
  onMouseDownRight: (e: React.MouseEvent<HTMLDivElement>) => void;
}

export const AssignmentResizeHandles = memo(
  ({
    isResizeLeftDisabled,
    isResizeRightDisabled,
    isResizing,
    isDragging,
    textColor,
    opacity,
    onMouseDownLeft,
    onMouseDownRight,
  }: AssignmentResizeHandlesProps) => {
    return (
      <>
        {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
        <div
          className={cn('assignment absolute bottom-0 -left-1 top-0 pt-1.5 cursor-ew-resize', {
            'cursor-default pointer-events-none': isResizeLeftDisabled,
          })}
          onMouseDown={onMouseDownLeft}
        >
          {!isResizeLeftDisabled && !isResizing && !isDragging && (
            <Tally2Icon
              size={12}
              className="invisible rotate-180 group-hover:visible"
              style={{
                color: textColor,
                opacity,
              }}
            />
          )}
        </div>
        {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
        <div
          className={cn('assignment absolute bottom-0 pt-1.5 -right-1 top-0 cursor-ew-resize', {
            'cursor-default pointer-events-none': isResizeRightDisabled,
          })}
          onMouseDown={onMouseDownRight}
        >
          {!isResizeRightDisabled && !isResizing && !isDragging && (
            <Tally2Icon
              size={12}
              className="invisible group-hover:visible"
              style={{
                color: textColor,
                opacity,
              }}
            />
          )}
        </div>
      </>
    );
  }
);

AssignmentResizeHandles.displayName = 'AssignmentResizeHandles';
